"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discardReplyOption_1 = require("./actions/discardReplyOption");
var saveReplyOption_1 = require("./actions/saveReplyOption");
var ReplyFull_1 = require("./components/ReplyFull");
var isReplyOptionDirty_1 = require("./utils/isReplyOptionDirty");
var React = require("react");
var ReplyOption = {
    key: 'reply',
    titleStringKey: 'optionTitle_reply',
    searchTermsStringKey: 'optionTitle_reply',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ReplyFull_1.default, null); },
        isDirty: isReplyOptionDirty_1.default,
        onSave: saveReplyOption_1.default,
        onDiscard: discardReplyOption_1.default,
    },
};
exports.default = ReplyOption;
//# sourceMappingURL=ReplyOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reply-option/lib/ReplyOption.js
// module id = 5046
// module chunks = 2